import withLeaveWarn from './withLeaveWarn';
import reducer, {
  setLeaveWarn,
  resetLeaveWarn,
  enableUnloadIgnore,
  disableUnloadIgnore,
} from './reducer';

export {
  withLeaveWarn,
  reducer,
  setLeaveWarn,
  resetLeaveWarn,
  enableUnloadIgnore,
  disableUnloadIgnore,
};
export default {
  withLeaveWarn,
  reducer,
  setLeaveWarn,
  resetLeaveWarn,
  enableUnloadIgnore,
  disableUnloadIgnore,
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/LeaveWarn/index.js
 **/